const {
  REACT_APP_DELIVERY_COOKIE,
  REACT_APP_ACCEPTED_COOKIES,
  REACT_APP_USER_INFO,
} = process.env

const COOKIES = {
  MO_DA: REACT_APP_DELIVERY_COOKIE,
  MO_CA: REACT_APP_ACCEPTED_COOKIES,
  MO_UI: REACT_APP_USER_INFO,
  ZLCMID: '__zlcmid',
  GAEXP: '_gaexp',
  GA: '_ga',
  GID: '_gid',
  AMPLITUDE_ID: 'amplitude_id',
}

const NECESSARY_COOKIES = [
  COOKIES.MO_DA,
  COOKIES.MO_CA,
  COOKIES.MO_UI,
  COOKIES.ZLCMID,
  COOKIES.AMPLITUDE_ID,
]

const THIRD_PARTY_COOKIES = [COOKIES.GAEXP, COOKIES.GA, COOKIES.GID]

export { COOKIES, NECESSARY_COOKIES, THIRD_PARTY_COOKIES }
